import { c as _c } from "react/compiler-runtime";
import { SvgChevronright } from '@common/icon';
import { CustomLink } from '@/app/_components/CustomLink';
export function SectionHeader(t0) {
  const $ = _c(13);
  const {
    title,
    totalCount,
    moreHref
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="font-700 text-Gray-900 typo-body2 mobile-tablet:text-Gray-black">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== totalCount) {
    t2 = typeof totalCount === "number" ? <><span aria-hidden={true} className="size-4 rounded-pill bg-Gray-300" /><span className="font-700 text-Gray-black typo-body4 mobile-tablet:font-500">총 {totalCount.toLocaleString()}건</span></> : null;
    $[2] = totalCount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex items-center gap-8">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SvgChevronright className="size-14 mobile-tablet:size-12" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== moreHref) {
    t5 = <CustomLink href={moreHref} className="flex h-40 items-center gap-4 rounded-xxsmall py-8 font-700 text-Gray-600 typo-body4 mobile-tablet:h-32 mobile-tablet:typo-caption1">더보기{t4}</CustomLink>;
    $[8] = moreHref;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="flex items-center justify-between py-6 mobile-tablet:px-20">{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}